import type { MixpanelUserProperties } from "./mixpanel_generated/user_properties";
import { getProvider } from "./registry";

export function setUserProperties(props: Partial<MixpanelUserProperties>): void {
  getProvider()?.setUserProperties(props);
}

export function identifyUser(distinctId: string): void {
  getProvider()?.identify(distinctId);
}

export function resetAnalytics(): void {
  getProvider()?.reset();
}
